import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en";
import es from "./locales/es";

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    en: en,
    es: es
  },
  lng: localStorage.getItem('i18nextLng') || 'es',
  fallbackLng: localStorage.getItem('i18nextLng') || 'es',
  debug: false,

  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false,

  interpolation: {
    escapeValue: false,
    formatSeparator: ","
  },

  react: {
    wait: true
  }
});

export default i18n;
